import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вес брутто (кг)", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вес нетто (кг)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Длина...",
          min: 400,
          value: model.length,
          "onUpdate:value": ($event: any) => ((model.length) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Ширина...",
          min: 400,
          value: model.width,
          "onUpdate:value": ($event: any) => ((model.width) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Высота...",
          min: 400,
          value: model.height,
          "onUpdate:value": ($event: any) => ((model.height) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createVNode(_component_DecimalControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Вес брутто...",
          min: 1,
          step: 1,
          value: model.weight,
          "onUpdate:value": ($event: any) => ((model.weight) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createVNode(_component_DecimalControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Вес нетто...",
          min: 1,
          step: 1,
          value: model.weight2,
          "onUpdate:value": ($event: any) => ((model.weight2) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}